// src/palettes/naturalPalettes.js
const naturalPalettes = [
  { name: 'Earth Tones', colors: ['#A27B5C', '#BF9270', '#DCD7C9', '#EBE3D5', '#664B36'] },
  { name: 'Forest Depths', colors: ['#1B4332', '#2D6A4F', '#40916C', '#52B788', '#0C261A'] },
  { name: 'Desert Dawn', colors: ['#FF7B54', '#FFB26B', '#FFD56B', '#939B62', '#4A3933'] },
  { name: 'Mountain Mist', colors: ['#757F9A', '#95A3BF', '#B5C6E5', '#D5E8FF', '#4A5165'] },
  { name: 'Autumn Leaves', colors: ['#8B4513', '#CD853F', '#DEB887', '#F4A460', '#5C2E0D'] },
  { name: 'Spring Meadow', colors: ['#90A955', '#ABC4A1', '#C7D6C3', '#E3EDE0', '#4F5F2F'] },
  { name: 'Rustic Charm', colors: ['#8B5E3C', '#A16A4C', '#C39E70', '#E0C097', '#5D3A1A'] },
  { name: 'Woodland', colors: ['#3B2F2F', '#5A4E4D', '#7B6A6A', '#A08A8A', '#D1B2B2'] },
  { name: 'River Stone', colors: ['#B0B0B0', '#969696', '#7D7D7D', '#646464', '#4B4B4B'] },
  { name: 'Blossom', colors: ['#FAD0C3', '#F8B195', '#F67280', '#C06C84', '#6C5B7B'] },
  { name: 'Organic Green', colors: ['#006400', '#228B22', '#32CD32', '#66CDAA', '#8FBC8F'] },
  { name: 'Sun-Kissed Sand', colors: ['#F4A460', '#D2B48C', '#DEB887', '#F5DEB3', '#FFE4B5'] },
  { name: 'Wildflower', colors: ['#FF69B4', '#FFB6C1', '#FFC0CB', '#FFDAB9', '#FFE4E1'] },
  { name: 'Rainforest', colors: ['#0B3D91', '#0E4D92', '#1E90FF', '#00BFFF', '#87CEFA'] },
  { name: 'Canyon Clay', colors: ['#B7410E', '#CD5C5C', '#F08080', '#FA8072', '#FFA07A'] },
  { name: 'Meadow Green', colors: ['#7CFC00', '#7FFF00', '#ADFF2F', '#9ACD32', '#6B8E23'] },
  { name: 'Dew Drop', colors: ['#E0FFFF', '#B0E0E6', '#ADD8E6', '#87CEEB', '#4682B4'] },
  { name: 'Coastal Breeze', colors: ['#A3D5FF', '#7FC8FF', '#5BB1FF', '#3A9CFF', '#1C85FF'] },
  { name: 'Misty Morning', colors: ['#DADADA', '#C0C0C0', '#A6A6A6', '#8C8C8C', '#727272'] },
  { name: 'Golden Harvest', colors: ['#E3B778', '#D4A668', '#C78A55', '#B97B42', '#AD6C30'] },
  { name: 'Riverbank', colors: ['#7F6741', '#8F7542', '#A0874A', '#B29851', '#C3AA59'] },
  { name: 'Prairie Sky', colors: ['#77AADD', '#6699CC', '#5588BB', '#4477AA', '#336699'] },
  { name: 'Mossy Rock', colors: ['#5C5C3D', '#6B6B4E', '#7A7A5F', '#898970', '#989881'] },
  { name: 'Sunset Field', colors: ['#FFB347', '#FFA54F', '#FF9638', '#FF8730', '#FF7829'] },
  { name: 'Ocean Tide', colors: ['#0077BE', '#009FDA', '#00BFE2', '#00D4E4', '#00E9E6'] },
  { name: 'Autumn Orchard', colors: ['#D17F41', '#C0723B', '#AF5F32', '#9C4B29', '#893820'] },
  { name: 'Woodland Fern', colors: ['#4C8C4A', '#5CA05B', '#6CB36D', '#7CB880', '#8CCB92'] },
  { name: 'River Moss', colors: ['#556B2F', '#6B8E23', '#7C9A33', '#8DAC43', '#9EBB54'] },
  { name: 'Sandy Dunes', colors: ['#EDC9AF', '#E6B89C', '#DFAB89', '#D8A076', '#D19A63'] },
  { name: 'Alpine Mist', colors: ['#B0C4DE', '#A2B9D6', '#94AED0', '#86A3C8', '#7898C2'] },
  { name: 'Rustic Field', colors: ['#A0522D', '#8B4513', '#7B3F12', '#6A3911', '#59330F'] },
  { name: 'Twilight Grove', colors: ['#2C3E50', '#34495E', '#3E5872', '#475A7F', '#505C8B'] },
];

export default naturalPalettes;
